import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";
import { trackEvent } from "apps/web/src/reporting/reporting";
import { useState } from "react";
import { BaseBulkEditProps, BaseContentProps } from "../types";
import BaseContent from "./BaseContent";

interface GuestOrderingContentProps extends BaseContentProps {
  onBulkEdit: BaseBulkEditProps["onBulkEdit"];
}

const GuestOrderingContent = ({ isOpen, onBack, onCancel, onBulkEdit, mealMenuInstances, saving }: GuestOrderingContentProps) => {
  const mealMenuIds = mealMenuInstances.map(mealMenuInstance => mealMenuInstance.id);
  const someEnabled = mealMenuInstances.some(mealMenuInstance => mealMenuInstance.isGuestOrderingEnabled);
  const everyEnabled = mealMenuInstances.every(mealMenuInstance => mealMenuInstance.isGuestOrderingEnabled);
  const [isGuestOrderingEnabled, setEnableGuestOrdering] = useState<boolean | null>(someEnabled === everyEnabled ? everyEnabled : null);

  const onChange = (value: boolean) => {
    setEnableGuestOrdering(value);
    trackEvent(`Nutrition | Kitchen | Menu Schedule | Bulk Edit | ${value ? "GuestOrderingEnabled" : "GuestOrderingNotEnabled"}`, {
      menuIds: mealMenuIds,
    });
  };

  return (
    <BaseContent
      isOpen={isOpen}
      onCancel={onCancel}
      saving={saving}
      onSubmit={async () => {
        if (isGuestOrderingEnabled !== null) {
          await onBulkEdit({
            mealMenuIds,
            actionType: "guestOrdering",
            sharingState: null,
            notificationSentBeforeOrderDueInMinutes: null,
            timingState: null,
            isGuestOrderingEnabled,
          });
        }
        onBack();
      }}
      title={`Set Guest Ordering for ${mealMenuInstances.length} Meal Menu(s)`}
      renderContent={() => (
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <FormControlLabel
            label={<Box>
              <Typography variant="body1">Enable Guest Ordering</Typography>
              <Typography variant="body2" color={"mediumEmphasisText"}>
                Will allow guests to place orders on these menus
              </Typography>
            </Box>}
            control={
              <Checkbox
                checked={isGuestOrderingEnabled ?? false}
                indeterminate={isGuestOrderingEnabled === null}
                onChange={e => onChange(e.target.checked)}
                sx={{ mb: 2 }}
              />
            }
          />
        </Box>
      )}
      submitDisabled={mealMenuInstances.length === 0 || saving || isGuestOrderingEnabled === null}
    />
  );
};

export default GuestOrderingContent;
